var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixFedinfraExportserviceV1ExportAsyncJob from '@wix/ambassador-fedinfra-exportservice-v1-export-async-job/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var ArrayFieldDelimiter;
(function (ArrayFieldDelimiter) {
    ArrayFieldDelimiter["SEMICOLON"] = "SEMICOLON";
    ArrayFieldDelimiter["SEMICOLON_AND_SPACE"] = "SEMICOLON_AND_SPACE";
})(ArrayFieldDelimiter || (ArrayFieldDelimiter = {}));
export var QueryFieldNumber;
(function (QueryFieldNumber) {
    /** message QuerySomethingRequest { .wix.common.QueryV2 query = 1; } */
    QueryFieldNumber["DEFAULT"] = "DEFAULT";
    QueryFieldNumber["FIELD_2"] = "FIELD_2";
    QueryFieldNumber["FIELD_3"] = "FIELD_3";
    QueryFieldNumber["FIELD_4"] = "FIELD_4";
    QueryFieldNumber["FIELD_5"] = "FIELD_5";
    QueryFieldNumber["FIELD_6"] = "FIELD_6";
    QueryFieldNumber["FIELD_7"] = "FIELD_7";
    /** message QuerySomethingRequest { .wix.common.QueryV2 query = 8; } */
    QueryFieldNumber["FIELD_8"] = "FIELD_8";
    QueryFieldNumber["FIELD_9"] = "FIELD_9";
})(QueryFieldNumber || (QueryFieldNumber = {}));
export var RuleType;
(function (RuleType) {
    RuleType["VALIDATION"] = "VALIDATION";
    RuleType["OTHER"] = "OTHER";
    RuleType["MAX"] = "MAX";
    RuleType["MIN"] = "MIN";
    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
    RuleType["MAX_SIZE"] = "MAX_SIZE";
    RuleType["MIN_SIZE"] = "MIN_SIZE";
    RuleType["FORMAT"] = "FORMAT";
    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
    RuleType["FIELD_NOT_ALLOWED"] = "FIELD_NOT_ALLOWED";
    RuleType["ONE_OF_ALIGNMENT"] = "ONE_OF_ALIGNMENT";
})(RuleType || (RuleType = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    /** Job was created, but not started yet. */
    Status["INITIALIZED"] = "INITIALIZED";
    /** Job has started and is in progress. */
    Status["PROCESSING"] = "PROCESSING";
    /** Job is finished. */
    Status["FINISHED"] = "FINISHED";
    /** Job has failed. */
    Status["FAILED"] = "FAILED";
})(Status || (Status = {}));
export var ProductType;
(function (ProductType) {
    ProductType["unspecified_product_type"] = "unspecified_product_type";
    ProductType["physical"] = "physical";
    ProductType["digital"] = "digital";
})(ProductType || (ProductType = {}));
export var InventoryStatus;
(function (InventoryStatus) {
    InventoryStatus["IN_STOCK"] = "IN_STOCK";
    InventoryStatus["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    InventoryStatus["PARTIALLY_OUT_OF_STOCK"] = "PARTIALLY_OUT_OF_STOCK";
})(InventoryStatus || (InventoryStatus = {}));
export var MeasurementUnit;
(function (MeasurementUnit) {
    MeasurementUnit["UNSPECIFIED"] = "UNSPECIFIED";
    MeasurementUnit["ML"] = "ML";
    MeasurementUnit["CL"] = "CL";
    MeasurementUnit["L"] = "L";
    MeasurementUnit["CBM"] = "CBM";
    MeasurementUnit["MG"] = "MG";
    MeasurementUnit["G"] = "G";
    MeasurementUnit["KG"] = "KG";
    MeasurementUnit["MM"] = "MM";
    MeasurementUnit["CM"] = "CM";
    MeasurementUnit["M"] = "M";
    MeasurementUnit["SQM"] = "SQM";
    MeasurementUnit["OZ"] = "OZ";
    MeasurementUnit["LB"] = "LB";
    MeasurementUnit["FLOZ"] = "FLOZ";
    MeasurementUnit["PT"] = "PT";
    MeasurementUnit["QT"] = "QT";
    MeasurementUnit["GAL"] = "GAL";
    MeasurementUnit["IN"] = "IN";
    MeasurementUnit["FT"] = "FT";
    MeasurementUnit["YD"] = "YD";
    MeasurementUnit["SQFT"] = "SQFT";
})(MeasurementUnit || (MeasurementUnit = {}));
export var MediaItemType;
(function (MediaItemType) {
    MediaItemType["unspecified_media_item_type"] = "unspecified_media_item_type";
    MediaItemType["image"] = "image";
    MediaItemType["video"] = "video";
    MediaItemType["audio"] = "audio";
    MediaItemType["document"] = "document";
    MediaItemType["zip"] = "zip";
})(MediaItemType || (MediaItemType = {}));
export var OptionType;
(function (OptionType) {
    OptionType["unspecified_option_type"] = "unspecified_option_type";
    OptionType["drop_down"] = "drop_down";
    OptionType["color"] = "color";
})(OptionType || (OptionType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["UNDEFINED"] = "UNDEFINED";
    /** No discount */
    DiscountType["NONE"] = "NONE";
    DiscountType["AMOUNT"] = "AMOUNT";
    DiscountType["PERCENT"] = "PERCENT";
})(DiscountType || (DiscountType = {}));
export var FileType;
(function (FileType) {
    FileType["UNSPECIFIED"] = "UNSPECIFIED";
    FileType["SECURE_PICTURE"] = "SECURE_PICTURE";
    FileType["SECURE_VIDEO"] = "SECURE_VIDEO";
    FileType["SECURE_DOCUMENT"] = "SECURE_DOCUMENT";
    FileType["SECURE_MUSIC"] = "SECURE_MUSIC";
    FileType["SECURE_ARCHIVE"] = "SECURE_ARCHIVE";
})(FileType || (FileType = {}));
const _cancelExportAsyncJobRequest = {};
const _cancelExportAsyncJobResponse = {};
const _createExportAsyncJobRequest = {};
const _createExportAsyncJobResponse = {};
const _generateExportAsyncJobDownloadUrlRequest = {};
const _generateExportAsyncJobDownloadUrlResponse = {};
const _getExportAsyncJobRequest = {};
const _getExportAsyncJobResponse = {};
/**
 * Creates a new Export
 * @param query - WQL expression
 * @public
 * @documentationMaturity preview
 * @requiredField options.fields
 * @requiredField options.methodMetadata
 * @requiredField query
 * @adminMethod
 */
export function createExportAsyncJob(query, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            query: '$[0]',
            fields: '$[1].fields',
            arrayFieldDelimiter: '$[1].arrayFieldDelimiter',
            methodMetadata: '$[1].methodMetadata',
            methodSpec: '$[1].methodSpec',
            saveAs: '$[1].saveAs',
            testParams: '$[1].testParams',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createExportAsyncJobRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createExportAsyncJobResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['job']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([query, options]);
        const reqOpts = ambassadorWixFedinfraExportserviceV1ExportAsyncJob.createExportAsyncJob(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'query',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get a Export by id
 * @param jobId - Id of the Export to retrieve
 * @public
 * @documentationMaturity preview
 * @requiredField jobId
 * @adminMethod
 */
export function getExportAsyncJob(jobId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { jobId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getExportAsyncJobRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getExportAsyncJobResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['job']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([jobId]);
        const reqOpts = ambassadorWixFedinfraExportserviceV1ExportAsyncJob.getExportAsyncJob(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'jobId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @param jobId - Id of the Export to retrieve
 * @internal
 * @documentationMaturity preview
 * @requiredField jobId
 * @adminMethod
 */
export function cancelExportAsyncJob(jobId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { jobId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cancelExportAsyncJobRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cancelExportAsyncJobResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['job']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([jobId]);
        const reqOpts = ambassadorWixFedinfraExportserviceV1ExportAsyncJob.cancelExportAsyncJob(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'jobId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @param jobId - Id of the Export to retrieve
 * @internal
 * @documentationMaturity preview
 * @requiredField jobId
 * @adminMethod
 */
export function generateExportAsyncJobDownloadUrl(jobId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { jobId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateExportAsyncJobDownloadUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateExportAsyncJobDownloadUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['job']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([jobId]);
        const reqOpts = ambassadorWixFedinfraExportserviceV1ExportAsyncJob.generateExportAsyncJobDownloadUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'jobId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=fedinfra-exportservice-v1-export-async-job.universal.js.map